<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget
    :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
    ref="base" style="position: relative">


    <div
      class="w-full m-b-10 flex"
      v-if="iteminfo.config.displayType === 3"
    >
      <span class="fs-14 color-33 w-90">播放设置：</span>
      <RadioGroup class="w-full flex" v-model="iteminfo.config.pagePlay">
        <!--        <radio :label="1" size="small" class="color-33">-->
        <!--          <span class="fs-14 color-33" >跳页播放</span>-->
        <!--        </radio>-->
        <radio :label="0" size="small" class="m-r-10">
          <span class="fs-14 color-33">页面播放</span>
        </radio>
        <radio :label="2" size="small" class="m-r-10">
          <span class="fs-14 color-33">弹框播放</span>
        </radio>
      </RadioGroup>
    </div>

    <!--    满屏轮播不可设置内容来源-->
    <div
      class="w-full m-b-10 flex"
      v-if="iteminfo.config.displayType !== 4"
    >
      <span class="fs-14 color-33 w-90">内容来源：</span>
      <RadioGroup class="w-full flex" v-model="iteminfo.config.contentType">
        <radio :label="0" size="small" class="m-r-10">
          <span class="fs-14 color-33">自上传</span>
        </radio>
        <radio :label="1" size="small" class="m-r-10">
          <span class="fs-14 color-33">链接地址</span>
        </radio>
      </RadioGroup>
    </div>

    <div v-if="iteminfo.config.contentType===1">
      <!--      <div class="fs-14  color-33 m-b-10">链接:</div>-->
      <tooltip style="width: 100%"
               :disabled="!iteminfo.config.jumpObj.linkUrl"
               max-width="300">
        <Input element-id="input" ref="Input" placeholder="加载链接地址" id="input-product"
               readonly clearable
               v-model="iteminfo.config.jumpObj.linkUrl">
          <!--                 @on-change="visibilityChange"-->

          <span slot="append" class="icon-link" style="cursor: pointer"
                @click="showMaterialModal()"></span>
        </Input>
        <div slot="content" style="white-space: normal;">
          {{ iteminfo.config.jumpObj.linkUrl }}
        </div>
      </tooltip>
      <div class="flex a-center m-t-10   color-33">
        <div class="fs-14 color-33">行数限制：</div>
        <RadioGroup v-model="iteminfo.config.haslimit">
          <Radio class="m-l-5   color-33" :label="1">
            有限
          </Radio>
          <Radio class="m-l-10   color-33" :label="0">
            无限
          </Radio>
        </RadioGroup>
      </div>
      <div v-if="iteminfo.config.haslimit" class="m-v-10">
        <span class="fs-14 color-33 m-r-10">显示行数：</span>
        <Input placeholder="输入行数" class="w-120" v-model="iteminfo.config.rowCount"/>
      </div>

      <div class="flex a-center m-v-10   color-33">
        <div class="fs-14 color-33">显示标题：</div>
        <RadioGroup v-model="iteminfo.config.showMenuTitle">
          <Radio class="m-l-5   color-33" :label="0">
            隐藏
          </Radio>
          <Radio class="m-l-10   color-33" :label="1">
            显示
          </Radio>
        </RadioGroup>
      </div>
      <Input element-id="input" ref="Input" placeholder="标题内容"
             clearable v-if="iteminfo.config.showMenuTitle"
             v-model="iteminfo.config.menutitle"/>


    </div>

    <div
      class="h-30 flex a-center m-v-10 color-33"
      v-if="iteminfo.config.displayType === 1">
      <div class="fs-14 color-33">左右间距：</div>
      <Input
        class="fr w-100 m-l-20"
        type="number"
        v-model="iteminfo.config.hSpacing"
      >
        <span slot="append">px</span>
      </Input>
    </div>
    <div
      class="h-30 flex a-center m-v-10 color-33"
      v-if="iteminfo.config.displayType === 1">
      <div class="fs-14 color-33">上下间距：</div>
      <Input
        class="fr w-100 m-l-20"
        type="number"
        v-model="iteminfo.config.vSpacing"
      >
        <span slot="append">px</span>
      </Input>
    </div>

    <div v-if="iteminfo.config.contentType===0">

      <div class="fs-14 color-33">
        上传视频
      </div>
      <div class="fs-12 color-99 m-v-10">
        建议视频和图片比例为4:3或16:9，视频格式为mp4，图片格式为jpg或png。
      </div>
      <ul class="p-b-50">
        <li :key="index" class="m-b-10" style="background-color: #F2F2F2"
            v-for="(item,index) in iteminfo.config.datalist">
          <div class="flex" style="min-height: 180px">
            <div class="flex-1 p-v-20 p-l-20">
              <!--              单列 并排 列表 式-->
              <div style="min-height: 100px" v-if="iteminfo.config.displayType !== 4">
                <div class="flex a-center j-center">
                  <div class="p-r-5" style="width: 50%;">
                    <!--                  <up-load-video :vidupload="false" @funcallback="onVideoUpload($event,index)"-->
                    <!--                                 @uploadSuccess="uploadVideoSuccess($event,item)" accept="video/*"-->
                    <!--                                 style="height: 101px"-->
                    <!--                                 videoInfix="news/content/">-->
                    <!--                    <template v-slot:tip>-->
                    <div class="bg-white border o-hidden flex a-center j-center"
                         style="width: 100%;height: 101px;cursor: pointer;position: relative;top:0;left:0">
                      <div class="flex-column a-center j-center"
                           v-if="!item.videoUrl"
                           @click="choiceVideo(item)"
                           style="width: 100%;min-height: 100%;cursor: pointer;padding-bottom: 5px">
                        <img alt="" src="../../../assets/common/ic_upload_video@2x.png"
                             style="width: 32px;height: 32px">
                        <span class="m-t-10  color-66 fs-9">上传视频</span>
                      </div>
                      <img
                        v-if="item.videoUrl"
                        :src="getItemUrl(item)" alt=""
                        @click="previewVideo(item)"
                        style="width: 100%;min-height: 100%;object-fit: cover">

                      <div @click="deleteVideo(item)" class="delete-style"
                           style="top: 0;right: 0;"
                           v-if="item.videoUrl">
                        <span class="delete-inner"></span>
                      </div>
                      <i v-if="item.videoUrl"
                         @click="previewVideo(item)"
                         class="icon-player fs-30 text-white"
                         style="position: absolute;left: auto;right: auto"
                      ></i>

                      <div class="fz-14 flex-column"
                           style="width:100%;height:40px;color: green;position: absolute;bottom: 0;background-color: #00000040;justify-content: flex-end"
                           v-if="item.process">
                        <div
                          style="width: 100%;height: 35px;line-height: 30px;text-align: center;background-color: #00000050">
                          上传进度{{ item.process }}
                        </div>
                      </div>
                    </div>
                    <!--                    </template>-->
                    <!--                  </up-load-video>-->
                  </div>
                  <div class="p-l-5" style="width: 50%;">
                    <!--                  <up-load-image @uploadSuccess="uploadcoversuccess($event,item)" accept="image/*"-->
                    <!--                                 picurl="crop/crop/"-->
                    <!--                                 style="height: 101px">-->
                    <!--                    <template v-slot:tip>-->
                    <div class="bg-white border o-hidden position-relative flex a-center j-center"
                         @click="choicePic(item)"
                         style="width: 100%;height: 101px;cursor: pointer;left: 0;top: 0">
                      <div
                        v-if="!item.coverImgUrl"
                        class="flex a-center flex-column" style="width: 100%;min-height: 100%">
                        <img alt=""
                             src="../../../assets/common/ic_upload_picture@2x.png"
                             style="width: 30px;height: 30px">
                        <span class="color-66 m-t-10 fs-9">上传图片</span>
                      </div>
                      <div class="flex-column a-center j-center h-full">
                        <img v-if=item.coverImgUrl
                             :src="getCoverItemUrl(item)" alt=""
                             style="width: 100%;min-height: 100%;object-fit: cover">
                      </div>

                      <div @click.s.stop="deleteCoverImg(item)" class="delete-style absolute"
                           style="top: 0;right: 0;"
                           v-if="item.coverImgUrl">
                        <span class="delete-inner"></span>
                      </div>
                    </div>
                    <!--                    </template>-->
                    <!--                  </up-load-image>-->
                  </div>
                  <div class="flex-column a-center flex-s-0 h-full"
                       style="width: 50px;justify-content: space-between;height: 101px">
                    <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
                       class="icon-up fs-18"
                       style="cursor: pointer;"/>
                    <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
                       @click.stop="onDownClick(index)"
                       class="icon-down fs-18"
                       style="cursor: pointer;"/>
                    <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
                       style="cursor: pointer;color: #666666"/>
                  </div>
                </div>
                <div class="flex m-t-10" style="height: 34px;margin-right: 50px">
                  <Input placeholder="视频标题" v-model="item.videoTitle"></Input>
                </div>
              </div>
              <!--              全屏轮播 不要封面-->
              <div style="min-height: 100px" v-if="iteminfo.config.displayType === 4">
                <div class="flex a-center j-center">
                  <div class="p-r-5 w-full flex a-center j-center" style="width: 100%;">
                    <div class="bg-white border o-hidden flex a-center j-center"
                         style="width: 60%;height: 240px;cursor: pointer;position: relative;top:0;left:0">
                      <div class="flex-column a-center j-center"
                           v-if="!item.videoUrl"
                           @click="choiceVideo(item)"
                           style="width: 100%;min-height: 100%;cursor: pointer;padding-bottom: 5px">
                        <img alt="" src="../../../assets/common/ic_upload_video@2x.png"
                             style="width: 32px;height: 32px">
                        <span class="m-t-10  color-66 fs-9">上传视频</span>
                      </div>
                      <img
                        v-if="item.videoUrl"
                        :src="getItemUrl(item)" alt=""
                        @click="previewVideo(item)"
                        style="width: 100%;min-height: 100%;object-fit: cover">

                      <div @click="deleteVideo(item)" class="delete-style"
                           style="top: 0;right: 0;"
                           v-if="item.videoUrl">
                        <span class="delete-inner"></span>
                      </div>
                      <i v-if="item.videoUrl"
                         @click="previewVideo(item)"
                         class="icon-player fs-30 text-white"
                         style="position: absolute;left: auto;right: auto"
                      ></i>

                      <!--                      <div class="fz-14 flex-column"-->
                      <!--                           style="width:100%;height:40px;color: green;position: absolute;bottom: 0;background-color: #00000040;justify-content: flex-end"-->
                      <!--                           v-if="item.process">-->
                      <!--                        <div-->
                      <!--                          style="width: 100%;height: 35px;line-height: 30px;text-align: center;background-color: #00000050">-->
                      <!--                          上传进度{{ item.process }}-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                    </div>
                    <!--                    </template>-->
                    <!--                  </up-load-video>-->
                  </div>
                  <div class="flex-column a-center flex-s-0 h-full"
                       style="width: 50px;justify-content: space-between;height: 101px">
                    <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
                       class="icon-up fs-18"
                       style="cursor: pointer;"/>
                    <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
                       @click.stop="onDownClick(index)"
                       class="icon-down fs-18"
                       style="cursor: pointer;"/>
                    <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
                       style="cursor: pointer;color: #666666"/>
                  </div>
                </div>
                <!--                全屏跳转链接设置-->
                <div class="bg-white flex border m-t-10" style="height: 34px;width: 320px"
                >
                  <Input :border="false" class="b-r" placeholder="标题名称" style="width: 100px"
                         v-model="item.jumpObj.linkName"></Input>
                  <tooltip style="width: 100%"
                           :disabled="!item.jumpObj.linkUrl"
                           max-width="250">

                    <Input :border="false"
                           class="input-link"
                           readonly clearable
                           width="200"
                           placeholder="跳转链接地址" v-model="item.jumpObj.linkUrl">
                  <span slot="append" style="cursor: pointer"
                        @click="showMaterialModal(item,index)">  <i class="icon-link"/> </span>
                    </Input>
                    <div slot="content" style="white-space: normal;">
                      {{ item.jumpObj.linkUrl }}
                    </div>
                  </tooltip>
                </div>

              </div>
            </div>
          </div>
        </li>


      </ul>

      <div class="p-b-20"
           style="position: absolute;bottom: 0;left: 20px;width:calc(100% - 40px);z-index: 999;background-color: white">
        <div @click="onItemAddClick" class="flex a-center j-center" key="abc"
             style="height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
          <Icon size="24" type="ios-add"/>
          <div class="m-l-2">添加视频</div>
        </div>
      </div>


    </div>


    <pic-choice-widget
      ref="picChoiceWidget"
      :on-ok="picChoiceOk"
    />

    <video-choice-widget
      ref="videoChoiceWidget"
      :on-ok="videoChoiceOk"
    />

    <materail-choice-weidget
      title="选择链接"
      :pages="choosePage()"
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"/>

    <!--    视频预览-->
    <Modal
      @on-visible-change="onVideoPrewModalClose"
      class-name="vertical-center-modal"
      footer-hide
      v-model="showVideoPrew"
      width="650">
      <video-prew :videoinfo="videoprewinfo" ref="prewplayer"/>
    </Modal>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import UpLoadVideo from '../../common/UpLoadVideo'
import PicChoiceWidget from '@/components/common/chiose/PicChoiceWidget'
import VideoChoiceWidget from '@/components/common/chiose/VideoChoiceWidget'
import VideoPrew from '@/components/common/VideoPrew'
import MaterailChoiceWeidget from '@/components/common/chiose/MaterialChoiceWidget'
import {getPages} from '@/components/common/chiose/MaterailChoiceWidgetUtil'

export default {
  name: 'VideoSettingWidget',
  components: {
    MaterailChoiceWeidget,
    VideoPrew,
    VideoChoiceWidget, UpLoadVideo, UpLoadImage, BaseSettingWidget, PicChoiceWidget,
  },
  props: {
    iteminfo: Object
  },
  watch: {
    'iteminfo.config.datalist.length': {
      handler (newValue, oldValue) {
        this.calcRowCount()
      },
      immediate: true,
    },
  },
  data () {
    return {
      // 点击item弹选择图片
      clickItem2ShowPicModal: {},
      // 点击item弹选择视频
      clickItem2ShowVideoModal: {},
      //点击item弹选择链接
      clickItem2ShowMaterialModal: {},

      // 视频预览
      showVideoPrew: false,
      videoprewinfo: {       //预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      },
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onItemAddClick () {
      this.iteminfo.config.datalist.push({
        id: 0,
        title: '',
        videoUrl: '',
        coverImgUrl: '',
        process: '',
        jumpObj:{
          linkName:'',
          linkUrl:''
        }
      })

      this.$nextTick(() => {
        if (this.$refs.base && this.$refs.base.$refs.scrollDiv) {
          let scrollHeight = this.$refs.base.$refs.scrollDiv.scrollHeight
          this.$refs.base.$refs.scrollDiv.scrollTo({top: scrollHeight, behavior: 'smooth'})
        }
      })
    },
    onDelClick (index) {
      let datalist = this.iteminfo.config.datalist
      datalist.splice(index, 1)
      if (!datalist.length) {
        this.onItemAddClick()
      }
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    getCoverItemUrl (item) {
      let src = require('../../../assets/tempmenu/img_picture_abreast.png')
      if (item.coverImgUrl) {
        src = item.coverImgUrl
      }
      return src
    },
    getItemUrl (item) {
      let src = require('../../../assets/tempmenu/img_video_single.png')
      if (this.iteminfo.config.displayType === 1) {
        src = require('../../../assets/tempmenu/img_video_single.png')
      } else if (this.iteminfo.config.displayType === 2) {
        src = require('../../../assets/tempmenu/img_video_abreast.png')
      } else if (this.iteminfo.config.displayType === 3) {
        src = require('../../../assets/tempmenu/img_video_abreast.png')
      }
      if (item.coverImgUrl) {
        return item.coverImgUrl
      }
      if (item.mp4Url && item.mp4Url.endsWith('.mp4')) {
        src = item.mp4Url + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      } else if (item.videoUrl && item.videoUrl.endsWith('.mp4')) {
        src = item.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      }
      return src
    },
    uploadcoversuccess (data, item) {
      if (data && data.length) {
        item.coverImgUrl = data[0].url
      }

    },
    uploadVideoSuccess (data, item) {
      if (data && data.length) {
        item.videoUrl = data[0].videoUrl || ''
        if (!item.title) {
          item.title = data[0].localfile.name || ''
        }
      }
      item.process = ''
    },
    onVideoUpload (data, index) {
      if (data) {
        this.iteminfo.config.datalist[index].process = Number.parseInt(data * 100) + '%'
      }
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    choicePic (item) {
      this.clickItem2ShowPicModal = item
      this.$refs.picChoiceWidget.show()
    },
    choiceVideo (item) {
      this.clickItem2ShowVideoModal = item
      this.$refs.videoChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        let pic = data[0]
        this.clickItem2ShowPicModal.coverImgUrl = pic.url
        this.clickItem2ShowPicModal.coverContentLink = pic.linkurl
        this.clickItem2ShowPicModal.width = pic.width
        this.clickItem2ShowPicModal.height = pic.height
      }
    },
    //视频弹框ok按钮
    videoChoiceOk (result) {
      if (result && result.length) {
        let video = result[0]
        let item = this.clickItem2ShowVideoModal
        item.videoTitle = video.videoTitle
        item.videoUrl = video.videoUrl
        item.coverImgUrl = video.coverUrl
        //本地播放url
        item.mp4Url = video.sourceUrl

        item.contentLink = video.linkurl
        //需要清空
        item.coverContentLink = ''
      }
    },
    // 删除按钮
    deleteVideo (item) {
      item.videoUrl = ''
      item.mp4Url = ''
      item.title = ''
      item.contentLink = ''
      item.coverContentLink = ''
      item.coverImgUrl = ''
    },

    //删除封面图片
    deleteCoverImg (item) {
      item.coverImgUrl = ''
      item.coverContentLink = ''
    },
    // 视频预览
    previewVideo (item) {
      this.videoprewinfo = {
        videoAliVid: '',
        videoUrl: item.mp4Url || item.videoUrl,
        coverUrl: item.coverImgUrl,
        videoTitle: item.videoTitle,
      }
      this.showVideoPrew = true
    },
    //关闭视频预览
    onVideoPrewModalClose (status) {
      if (!status) {
        this.videoprewinfo = {
          videoUrl: '',
          videoAliVid: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },
    /**
     * 自上传 需要计算rowCount
     */
    calcRowCount () {
      if (this.iteminfo.config.contentType === 0) {
        let datalist = this.iteminfo.config.datalist
        if (this.iteminfo.config.displayType === 1) {
          this.iteminfo.config.rowCount = Math.ceil(datalist.length / 2)
        } else if (this.iteminfo.config.displayType === 2) {
          this.iteminfo.config.rowCount = datalist.length
        } else if (this.iteminfo.config.displayType === 3) {
          this.iteminfo.config.rowCount = datalist.length
        }
      } else {

      }
    },

    //链接选择///////////////////////////////////////////////////////////////////
    choosePage () {
      if (this.iteminfo.config.displayType !== 4) {    //视频通过 链接选择
        return getPages([2])
      } else {
        return getPages()                                 //满屏轮播 跳转链接选择
      }
    },
    showMaterialModal (row, index) {
      if (this.iteminfo.config.displayType === 4) {  //全屏跳转链接设置
        this.clickItem2ShowMaterialModal = row
      } else {    //内容通过链接设置
      }
      this.$refs.materialChoiceWidget.show()
    },
    materialChoiceOk (data) {
      if (this.iteminfo.config.displayType === 4) {  //全屏跳转链接设置
        this.clickItem2ShowMaterialModal.jumpObj.linkUrl = data[0].url
        return
      }
      if (data && data.length > 0) {            //内容通过链接设置
        this.iteminfo.config.jumpObj.linkUrl = data[0].url
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
